import { render } from "./w-dialog.vue?vue&type=template&id=4b9def86&scoped=true"
import script from "./w-dialog.vue?vue&type=script&lang=js"
export * from "./w-dialog.vue?vue&type=script&lang=js"

import "./w-dialog.vue?vue&type=style&index=0&id=4b9def86&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9def86"]])

export default __exports__